export default __webpack_public_path__ + "static/media/F4.6bbfb7a6.mp3";